import type { Xinglet } from '@xing-com/crate-xinglet';

import { Entry } from './entry';

export default class StartpageLoggedOut implements Xinglet {
  public getComponent() {
    return () => <Entry />;
  }
}
